<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">add segment</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                New segment description by {{ set.item }} set
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row class="subtitle-2 secondary--text text-left my-2">
                            I. Segment descriptions:
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="segment name" v-model="name" name="name"
                                    type="text" :rules="[rules.required]">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="min typical age" v-model.number="min_age"
                                    name="min_age" type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="max typical age" v-model.number="max_age"
                                    name="max_age" type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols=" 12" sm="6" md="4">
                                <v-select dense color="primary" label="dominant gender" v-model="gender"
                                    :items="DOMINANT_GENDER" name="gender" type="text" :rules="[rules.required]"
                                    @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="month's income" v-model="income" name="income"
                                    :items="INCOME_RANGE" type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="typical education level" v-model="education"
                                    :items="EDUCATION" name="education" :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="civil status" v-model="civil_status"
                                    :items="CIVIL_STATUS" name="civil_status" :rules="[rules.required]"
                                    @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="workplace" v-model="job" name="job"
                                    :items="WORKPLACE" :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="lifestyle" v-model="lifestyle" name="lifestyle"
                                    :items="LIFESTYLE" :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="motiv level" v-model.number="motiv_level"
                                    name="motiv" type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="peak size" v-model.number="peakSize"
                                    name="peakSize" type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea dense counter rows="2" outlined auto-grow color="primary"
                                    label="segment description" v-model="description" :rules="[rules.required]"
                                    @change="onceMore()">
                                </v-textarea>
                            </v-col>
                        </v-row>
                        
                        <v-row class="subtitle-2 secondary--text text-left my-2">
                            II. Segment parameters:
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="max price" v-model.number="priceMax"
                                    name="priceMax" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="min price" v-model.number="priceMin"
                                    name="priceMin" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Purchasing habits lowest price"
                                    v-model.number="lowPrice" name="lowPrice" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Purchasing habits best quality"
                                    v-model.number="bestQuality" name="bestQuality" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Purchasing preferences on-line"
                                    v-model.number="online" name="online" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Purchasing preferences off-line"
                                    v-model.number="offline" name="offline" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--values-->
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="family / kids" v-model.number="family"
                                    name="family" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="attractiveness"
                                    v-model.number="attractiveness" name="attractiveness" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="strong personality"
                                    v-model.number="personality" name="personality" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="social status" v-model.number="social_status"
                                    name="lowPrice" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="fun" v-model.number="fun" name="fun"
                                    type="text" :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="friendship" v-model.number="friendship"
                                    name="friendship" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="pets" v-model.number="pets" name="pets"
                                    type="text" :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="independent lifestyle"
                                    v-model.number="independent" name="lifestyle" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="High brand importance"
                                    v-model.number="brand_high" name="brand_high" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Somehow brand importance"
                                    v-model.number="brand_somehow" name="brand_somehow" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Not a brand importance"
                                    v-model.number="brand_not" name="brand_not" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--design-->
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Classic design preferences"
                                    v-model.number="design_classic" name="classic" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Business design preferences"
                                    v-model.number="design_business" name="business" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Casual design preferences"
                                    v-model.number="design_casual" name="casual" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Innovative design preferences"
                                    v-model.number="design_innovative" name="innovative" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Art design preferences"
                                    v-model.number="design_art" name="art" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level1 design preferences"
                                    v-model.number="design_1" name="level1" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level2 design preferences"
                                    v-model.number="design_2" name="level2" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level3 design preferences"
                                    v-model.number="design_3" name="level3" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level4 design preferences"
                                    v-model.number="design_4" name="level4" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level5 design preferences"
                                    v-model.number="design_5" name="level5" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--material-->
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level1 material preferences"
                                    v-model.number="material_1" name="material1" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level2 material preferences"
                                    v-model.number="material_2" name="material2" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level3 material preferences"
                                    v-model.number="material_3" name="material3" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level4 material preferences"
                                    v-model.number="material_4" name="material4" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level5 material preferences"
                                    v-model.number="material_5" name="material5" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--manufacturing-->
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level1 manufacturing preferences"
                                    v-model.number="manufacturing_1" name="manufacturing1" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level2 manufacturing preferences"
                                    v-model.number="manufacturing_2" name="manufacturing2" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level3 manufacturing preferences"
                                    v-model.number="manufacturing_3" name="manufacturing3" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level4 manufacturingn preferences"
                                    v-model.number="manufacturing_4" name="manufacturing4" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Level5 manufacturing preferences"
                                    v-model.number="manufacturing_5" name="manufacturing5" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error">{{ error }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="addSegment">Save
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" @click="reset">
                    Reset
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" @click="resetValidation">
                    Reset validation
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'AddSegment',
    props: ['set', 'round'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
            },
            //segment description
            name: '',
            max_age: null,
            min_age: null,
            gender: null,
            income: null,
            education: '',
            civil_status: '',
            job: '',
            lifestyle: null,
            motiv_level: 0,
            peakSize: 0,
            description: '',
            // variable parameters
            priceMax: 0,
            priceMin: 0,
            lowPrice: 0,
            bestQuality: 0,
            online: 0,
            offline: 0,
            family: 0,
            attractiveness: 0,
            personality: 0,
            social_status: 0,
            fun: 0,
            friendship: 0,
            pets: 0,
            independent: 0,
            brand_high: 0,
            brand_somehow: 0,
            brand_not: 0,
            design_classic: 0,
            design_business: 0,
            design_casual: 0,
            design_innovative: 0,
            design_art: 0,
            design_1: 0,
            design_2: 0,
            design_3: 0,
            design_4: 0,
            design_5: 0,
            material_1: 0,
            material_2: 0,
            material_3: 0,
            material_4: 0,
            material_5: 0,
            manufacturing_1: 0,
            manufacturing_2: 0,
            manufacturing_3: 0,
            manufacturing_4: 0,
            manufacturing_5: 0,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        game() {
            return this.$store.getters.game;
        },
        DOMINANT_GENDER() {
            return this.$store.getters.DOMINANT_GENDER;
        },
        INCOME_RANGE() {
            return this.$store.getters.INCOME_RANGE;
        },
        EDUCATION() {
            return this.$store.getters.EDUCATION;
        },
        CIVIL_STATUS() {
            return this.$store.getters.CIVIL_STATUS;
        },
        WORKPLACE() {
            return this.$store.getters.WORKPLACE;
        },
        LIFESTYLE() {
            return this.$store.getters.LIFESTYLE;
        },
    },
    methods: {
        onceMore() {
            this.error = ''
        },
        reset () {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation()
        },
        async addSegment() {
            /* console.log(this.game)*/
            if (this.$refs.form.validate()) {
                const age = [];
                age[0] = this.min_age;
                age[1] = this.max_age;

                const segment = [
                    {
                        name: this.name,
                        category: this.game.category,
                        peak_size: this.peakSize,
                        typical_age: age,
                        gender: this.gender,
                        income: this.income, 
                        education: this.education,
                        civil_status: this.civil_status,
                        job: this.job,
                        lifestyle: this.lifestyle,
                        description: this.description,
                        motiv_level: this.motiv_level,
                    }, 
                    {
                        gameId: Number(this.set.value),
                        round: Number(this.round),
                        max_price: this.priceMax,
                        min_price: this.priceMin,
                        lowest_price: this.lowPrice,
                        best_quality: this.bestQuality,
                        on_line: this.online,
                        off_line: this.offline,
                        family: this.family,
                        attractiveness: this.attractiveness,
                        personality: this.personality,
                        social_status: this.social_status,
                        fun: this.fun,
                        friendship: this.friendship,
                        pets: this.pets,
                        independent: this.independent,
                        brand_high: this.brand_high,
                        brand_somehow: this.brand_somehow,
                        brand_not: this.brand_not,
                        design_classic: this.design_classic,
                        design_business: this.design_business,
                        design_casual: this.design_casual,
                        design_innovative: this.design_innovative,
                        design_art: this.design_art,
                        design_1: this.design_1,
                        design_2: this.design_2,
                        design_3: this.design_3,
                        design_4: this.design_4,
                        design_5: this.design_5,
                        material_1: this.material_1,
                        material_2: this.material_2,
                        material_3: this.material_3,
                        material_4: this.material_4,
                        material_5: this.material_5,
                        manufacturing_1: this.manufacturing_1,
                        manufacturing_2: this.manufacturing_2,
                        manufacturing_3: this.manufacturing_3,
                        manufacturing_4: this.manufacturing_4,
                        manufacturing_5: this.manufacturing_5
                    }
                ]
                /* console.log(segment); */
                try {
                    //add segment 
                    await this.$store.dispatch('addSegment', segment)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            } 
        },
        closeDialog() {
            //reset
            this.dialog = false
            this.error = ''
        }
    },
    async mounted() {

        if (!this.game && this.set) {
            
            try {
                await this.$store.dispatch('fetchGame', this.set.value);
            }
            catch (error) {
                console.log(error.message)
            }
        }
    }
}
</script>
